<template>
  <div class="col-lg-6 showitem match-row" :id="'show-' + show.id">
    <div class="helper-button" v-on:click="showClicked()"></div>
    <div class="showimage-wrap">
      <img v-if="showImage" :src="showImage" class="showimage"/>
      <img v-else src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkkAQAAB8AG7jymN8AAAAASUVORK5CYII=" class="showimage noimage"/>
    </div>
    <span :class="'showrating ' + agelimitClass " v-if="isMovie">{{ agelimit }}</span>
    <div class="showdetails">
      <div class="showtitle"><h4>{{ show.text }}</h4><span class="showprice"></span></div>
      <div class="showresource">{{ show.resource_name }}</div>
      <div class="showtimecontainer">
        <div class="showtimewrap">
          <div class="showtime">{{ showTime }}</div>
          <div class="showduration" v-if="!parseInt(show.upcoming)">(&thinsp;{{ showDuration }}&thinsp;)</div>
        </div>
        <div class="showprice">{{ $filters.currency(show.price, settings.currency) }}</div>
      </div>
      <div class="showfooter" v-if="parseInt(show.upcoming, 10) !== 1">
        <div class="showbutton input-group">
          <multiselect v-model="numberOfSeats" v-if="!hasSeatMap" :options="showRemainingSeatOptions" :show-labels="false" :searchable="false" :allow-empty="false" :multiple="false"	@open="isSelectOpen = true" @close="isSelectOpen = false"></multiselect>
          <span :class="hasSeatMap ? '' : 'input-group-btn'">
            <button ref="addButton" type="button" :class="isShowAvailable ? 'btn btn-success' : 'btn btn-danger'" v-on:click="showClicked()">{{ _('Add') }}</button>
          </span>
        </div>
        <div :class="'showcapacity text-' + showCapacityClass">
          {{ showReservations }} / {{ showCapacity }} ({{ showScanned }})
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { DateTime, Duration } from 'luxon'
import Multiselect from 'vue-multiselect'

export default {
  data () {
    return {
      numberOfSeats: 1,
      isSelectOpen: false,
      showDateFormat: 'yyyy-MM-dd HH:mm'
    }
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters(['locale', 'dateFormat', 'timeFormat']),
    hasSeatMap () {
      return parseInt(this.show.showseatmap)
    },
    showTime () {
      if (parseInt(this.show.upcoming, 10) !== 1) {
        if (DateTime.fromFormat(this.show.start_date, this.showDateFormat).toFormat('d.M.yyyy') !== DateTime.fromFormat(this.show.end_date, this.showDateFormat).toFormat('d.M.yyyy')) {
          return DateTime.fromFormat(this.show.start_date, this.showDateFormat).toFormat(this.timeFormat) + ' - ' + DateTime.fromFormat(this.show.end_date, this.showDateFormat).toFormat(this.timeFormat) + ' (' + this._(DateTime.fromFormat(this.show.end_date, this.showDateFormat).toFormat('ddd')) + ' ' + DateTime.fromFormat(this.show.end_date, this.showDateFormat).toFormat(this.dateFormat) + ')'
        }
        return DateTime.fromFormat(this.show.start_date, this.showDateFormat).toFormat(this.timeFormat) + ' - ' + DateTime.fromFormat(this.show.end_date, this.showDateFormat).toFormat(this.timeFormat)
      }
      return ''
    },
    showDuration () {
      if (parseInt(this.show.upcoming, 10) !== 1) {
        const start = DateTime.fromFormat(this.show.start_date, this.showDateFormat)
        const end = DateTime.fromFormat(this.show.end_date, this.showDateFormat)
        const dur = end.diff(start, ['hours', 'minutes'])
        const h = Math.floor(dur.hours)
        const m = Math.floor(dur.minutes)
        return h + ' h ' + m + ' min'
      }
      return ''
    },
    showReservations () {
      return parseInt(this.show.resource_reservations, 10)
    },
    showCapacity () {
      return parseInt(this.show.resource_capacity, 10)
    },
    showScanned () {
      return parseInt(this.show.resource_confirmed, 10)
    },
    showRemainingSeats () {
      if(parseInt(this.showCapacity - this.showReservations, 10) < 1 || isNaN(parseInt(this.showCapacity - this.showReservations, 10))) return 0
      return this.showCapacity - this.showReservations
    },
    showCapacityClass () {
      var allocation = Math.round((this.showReservations / this.showCapacity) * 100)
      if (allocation < 50) {
        return 'success'
      }
      if (allocation < 75) {
        return 'warning'
      }
      return 'danger'
    },
    showImage () {
      return this.show.image
    },
    isShowAvailable () {
      return this.showRemainingSeats > 0
    },
    showRemainingSeatOptions() {
      let returnValues = []
      for (let i = 0; i < this.showRemainingSeats; i++) {
        returnValues.push(i+1)
      }
      return returnValues;
    },
    isMovie () {
      return true;
      // We has movielist yeh
    },
    agelimit () {
      return (this.show.agelimit ? this.show.agelimit : '-')
    },
    agelimitClass() {
      switch (this.show.agelimit) {
        case 'S':
        case 'K-S':
        case 'KS':
        case '3':
          return 'agelimit-s'
          break
        case '7':
        case 'K-7':
        case 'K7':
          return 'agelimit-7'
          break
        case '12':
        case 'K-12':
        case 'K12':
          return 'agelimit-12'
          break
        case '16':
        case 'K-16':
        case 'K16':
          return 'agelimit-16'
          break
        case '18':
        case 'K-18':
        case 'K18':
          return 'agelimit-18'
          break
        default:
          return 'agelimit-unknown'
          break
      }
    }
  },
  props: ['show', 'baseDomain', 'settings'],
  methods: {
    showClicked () {
      if(this.isShowAvailable) {
        this.$emit('showClicked', this.show, this.numberOfSeats)
        this.numberOfSeats = 1
        this.$refs.addButton.blur()
      }
    }
  }
}

</script>